module.exports = __webpack_public_path__ + "static/media/wd6.38857ecd.jpeg";